import { useEffect } from "react";
import { useCallback } from "react";
import {
  updateNewSchemaColorHexaCode,
  updateNewSchemaTextColorHexaCode,
  updateShowNewSchemaColorHexaCode,
  useUiValue,
} from "stores/uiContext";

const useNewColorSchemaOptions = () => {
  const [
    { newSchemaColorHexaCode, newSchemaTextColorHexaCode, showNewSchemaColor },
    dispatch,
  ] = useUiValue();

  useEffect(() => {
    dispatch(updateNewSchemaColorHexaCode(newSchemaColorHexaCode));
    dispatch(updateNewSchemaTextColorHexaCode(newSchemaTextColorHexaCode));
    dispatch(updateShowNewSchemaColorHexaCode(showNewSchemaColor));
  }, []);

  const updateNewSchemaColorCode = useCallback(
    (hexaCode) => {
      dispatch(updateNewSchemaColorHexaCode(hexaCode));
    },
    [newSchemaColorHexaCode]
  );
  const updateNewSchemaTextColorCode = useCallback(
    (hexaCode) => {
      dispatch(updateNewSchemaTextColorHexaCode(hexaCode));
    },
    [newSchemaTextColorHexaCode]
  );
  const updateShowNewSchemaColor = useCallback(
    (flag) => {
      dispatch(updateShowNewSchemaColorHexaCode(flag));
    },
    [showNewSchemaColor]
  );

  return {
    newSchemaColorHexaCode,
    newSchemaTextColorHexaCode,
    showNewSchemaColor,
    updateNewSchemaColorCode,
    updateNewSchemaTextColorCode,
    updateShowNewSchemaColor,
  };
};
export default useNewColorSchemaOptions;
